<div class="page-header">
    <strong class="title">{{title}}</strong>
    <div class="float-end ">
        <ng-container *ngFor="let button of buttons">
            <dx-button class="m-2" [class]="button.cssClass" (click)="onClick(button)">
                <i [class]="button.icon" *ngIf="button.icon; else buttonEle"></i>
                <ng-template #buttonEle>{{button.name}}</ng-template>
            </dx-button>
        </ng-container>
    </div>
</div>